import { useEffect, useState } from "react";
import { fairyDustCursor } from "cursor-effects";

const FairyDustCursor = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    // Only load on desktop devices for performance
    const checkDevice = () => {
      setIsDesktop(window.innerWidth >= 1024 && !('ontouchstart' in window));
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  useEffect(() => {
    if (!isDesktop) return;

    const cursor = fairyDustCursor({
      color: "#22d4fd",
      size: 4,
      count: 12,
      duration: 800,
      opacity: 0.4,
      rise: 40,
    });

    return () => {
      if (cursor) cursor();
    };
  }, [isDesktop]);

  return null;
};

export default FairyDustCursor;
